import { z } from "zod";

export const defaultsScheme = z.object({
    enable_reservations: z.boolean(),
    enable_location_reservations: z.boolean(),
    allow_negative_stock: z.boolean(),
});

export type DefaultsFormTyping = z.infer<typeof defaultsScheme>;
